import styled, { css } from 'styled-components';

import { getCDNImageUrl } from '@/helpers/cdn';

import { GameItemSize } from '@/components/GameItem/styled';

const lobbySpins = getCDNImageUrl('/lobbySpins.webp');

interface ScLobbyGamesSlideProps {
  rows: number;
  cols: number;
}

export const ScLobbyGamesSlide = styled.div<ScLobbyGamesSlideProps>`
  display: grid;
  grid-template-columns: ${({ cols }) => `repeat(${cols}, 1fr)`};
  grid-template-rows: ${({ rows }) => `repeat(${rows}, 1fr)`};
  grid-gap: 16px;
`;

export interface ScShowAllGamesCardProps {
  black?: boolean;
  size?: GameItemSize;
}

export const ScShowAllGamesCard = styled.div<ScShowAllGamesCardProps>`
  max-height: 100%;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: url(${lobbySpins}) center no-repeat;
  background-color: ${({ theme, black }) =>
    black ? theme.blackColor : theme.grayLightColor};
  overflow: hidden;

  ${({ size }) => {
    switch (size) {
      case GameItemSize.L:
      case GameItemSize.M:
        return css`
          padding: 12%;
        `;
      case GameItemSize.S:
      default:
        return css`
          padding: 8px;
        `;
    }
  }}
  a {
    width: 100%;
  }
  .text {
    @media (max-width: 400px) {
      font-size: 10px;
    }
  }
`;
